import {Board} from '../board';
import {ScoreCalculator} from '../common/score-calculator';
import {PlacedBin} from '../placed-bin';

export class CenteringScoreCalculator extends ScoreCalculator {

    private static getDistance(x1: number, y1: number, x2: number, y2: number): number {
        const legA = x1 - x2;
        const legB = y1 - y2;

        return Math.sqrt(legA * legA + legB * legB);
    }

    private boardCenterX: number;
    private boardCenterY: number;
    private boardDiagonal: number;

    constructor(
        board: Board,
        placedBins: PlacedBin[]
    ) {
        super(board, placedBins);

        this.updateBoardMeta();
    }

    public override calc(placedBin: PlacedBin): number {
        const binCenterX = placedBin.x + Math.ceil(placedBin.w / 2);
        const binCenterY = placedBin.y + Math.ceil(placedBin.h / 2);

        const centerDistance = CenteringScoreCalculator.getDistance(
            this.boardCenterX,
            this.boardCenterY,
            binCenterX,
            binCenterY
        );

        return 100 - Math.round(centerDistance * 100 / this.boardDiagonal);
    }

    private updateBoardMeta(): void {
        this.boardCenterX = Math.ceil(this.board.w / 2);
        this.boardCenterY = Math.ceil(this.board.h / 2);
        this.boardDiagonal = CenteringScoreCalculator.getDistance(0, 0, this.board.w, this.board.h);
    }

}
